var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16.6902,
    height: 16.6674,
    viewBox: "0 0 16.6902 16.6674",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.35684 0C3.75447 0 0.0235113 3.73096 0.0235113 8.33333C0.0162262 10.2576 0.682505 12.1238 1.90684 13.6083L0.240178 15.275C0.0037242 15.5146 -0.0653193 15.873 0.065178 16.1833C0.206735 16.49 0.519391 16.6809 0.856845 16.6667H8.35684C12.9592 16.6667 16.6902 12.9357 16.6902 8.33333C16.6902 3.73096 12.9592 0 8.35684 0ZM5.02351 7.5C4.56327 7.5 4.19018 7.8731 4.19018 8.33333C4.19018 8.79357 4.56327 9.16667 5.02351 9.16667C5.48375 9.16667 5.85684 8.79357 5.85684 8.33333C5.85684 7.8731 5.48375 7.5 5.02351 7.5ZM8.35684 7.5C7.89661 7.5 7.52351 7.8731 7.52351 8.33333C7.52351 8.79357 7.89661 9.16667 8.35684 9.16667C8.81708 9.16667 9.19018 8.79357 9.19018 8.33333C9.19018 7.8731 8.81708 7.5 8.35684 7.5ZM10.8568 8.33333C10.8568 7.8731 11.2299 7.5 11.6902 7.5C12.1504 7.5 12.5235 7.8731 12.5235 8.33333C12.5235 8.79357 12.1504 9.16667 11.6902 9.16667C11.2299 9.16667 10.8568 8.79357 10.8568 8.33333ZM2.86518 15H8.35684C11.5372 14.9975 14.2729 12.7489 14.8911 9.62917C15.5093 6.50948 13.8378 3.38752 10.8987 2.17243C7.95961 0.957332 4.57149 1.98749 2.8062 4.63293C1.04091 7.27838 1.39008 10.8024 3.64018 13.05C3.79719 13.2039 3.88705 13.4135 3.89018 13.6333C3.88925 13.856 3.79922 14.0691 3.64018 14.225L2.86518 15Z",
    fill: "#505050"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.59eddf315505051826d62b00aca5e2eb.svg";
export { ForwardRef as ReactComponent };